import { Injectable } from '@angular/core';
import { URL_SERVICIOS, HTTP_OPTIONS } from '../shared/config/config';
import { HttpClient } from '@angular/common/http';
import { IPaymentCapacity, PaymentCapacity, Petition, DatatableRootObject, DataTablesResponse, PayCapReason } from '../interfaces/interfaces.index';
const URL = `${URL_SERVICIOS}PaymentCapacity`;

@Injectable({
  providedIn: 'root'
})
export class PaymentCapacityService {

  constructor(private http: HttpClient) { }

  getPaymentCapacityStore = () =>  {
    if (sessionStorage.getItem('capacidadPago')){
     return JSON.parse(sessionStorage.getItem('capacidadPago'));
    }
  }

  setPaymentCapacityStore = (capacity: PaymentCapacity) => sessionStorage.setItem("capacidadPago", JSON.stringify(capacity));

  getPaymentCapacity = (id: number) => this.http.get<PaymentCapacity>(`${URL}/${id}`, HTTP_OPTIONS);

  getPaymentCapacityById = (id: number) => this.http.get<PaymentCapacity>(`${URL}/${id}`, HTTP_OPTIONS);

  postPaymentCapacity = (paymentCapacity: PaymentCapacity, secondHolder = false) =>
    this.http.post<Petition[]>(`${URL}?secondHolder=${secondHolder}`, JSON.stringify(paymentCapacity), HTTP_OPTIONS)

  getPaymentsCapacityDatatables = (tableObj: DatatableRootObject) =>
    this.http.post<DataTablesResponse<PayCapReason>>(`${URL}/datatable`, tableObj, HTTP_OPTIONS)

  getPaymentCapacityDatatables = (tableObj: DatatableRootObject) =>
    this.http.post<DataTablesResponse<PaymentCapacity>>(`${URL}/datatables`, tableObj, HTTP_OPTIONS)

  getPaymentByPetition = (petitionId: number, userId) => this.http.get<PaymentCapacity>(`${URL}/petition/${petitionId}?userId=${userId}`, HTTP_OPTIONS);

  getPaymentResultbyId = (id: string) => this.http.get<PayCapReason>(`${URL}/result/${id}`, HTTP_OPTIONS);

  rexamineOrClose = (id: string, closed: boolean) =>
    this.http.put<PayCapReason>(`${URL}/${id}/${(closed) ? 'closed' : 'Reexamine'}`, null, HTTP_OPTIONS)

  getPaymentsCapacityReport = (startDate: string, endDate: string) => this.http.get<IPaymentCapacity[]>(`${URL}/report?startDate=${startDate}&endDate=${endDate}`);

  putPaymentCapacity = (paymentCapacity: PaymentCapacity) =>
    this.http.put<Petition[]>(URL, JSON.stringify(paymentCapacity), HTTP_OPTIONS)

  postPartialPaymentCapacity = (paymentCapacity: PaymentCapacity) =>
    this.http.post<Petition>(`${URL}/partial`, JSON.stringify(paymentCapacity), HTTP_OPTIONS)
}
